import Scene from "./Scene";
import common from "../common";
import {translate} from "../utils";
import SceneTitlePanel from "../ui/SceneTitlePanel";
import MuteMusicButton from "../ui/MuteMusicButton";

export default class SettingScene extends Scene {

    constructor() {
        super();
    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this._bg.tint = 0x0;
        this._bg.alpha = 0.7;
        this._bg.interactive = true;
        this.addChild(this._bg);

        this._panel = new PIXI.NineSlicePlane(P3.assets.texture("paper"), 52, 52, 52, 52);
        this._panel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._panel.width = 640;
        this._panel.pivot.set(this._panel.width / 2, this._panel.height / 2);
        this.addChild(this._panel);

        this._titleLabel = new SceneTitlePanel(translate("settings"));
        this._titleLabel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 160);
        this.addChild(this._titleLabel);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_large_out");
        states.down = P3.assets.texture("btn_primary_large_down");
        states.over = P3.assets.texture("btn_primary_large_over");
        states.icon = P3.assets.texture("icon_play");

        this._closeButton = new P3.Button(states);
        this._closeButton.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 160);
        this._closeButton.signals.click.once(this._onClose, this);
        //   this._closeButton.voSoundName = "vo_ui_close";
        this._closeButton.clickSoundName = "sfx_click";
        this._closeButton.overSoundName = "sfx_rollover";
        this.addChild(this._closeButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_small_out");
        states.over = P3.assets.texture("btn_primary_small_over");
        states.down = P3.assets.texture("btn_primary_small_down");
        states.icon = P3.assets.texture("icon_music_on");
        states.iconAlt = P3.assets.texture("icon_music_off");

        this._muteMusicButton = new MuteMusicButton(states);
        this._muteMusicButton.position.set(common.STAGE_WIDTH * 0.5 - 90, common.STAGE_HEIGHT * 0.5);
        this._muteMusicButton.clickSoundName = "sfx_click";
        this._muteMusicButton.overSoundName = "sfx_rollover";
        this.addChild(this._muteMusicButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_small_out");
        states.over = P3.assets.texture("btn_primary_small_over");
        states.down = P3.assets.texture("btn_primary_small_down");
        states.icon = P3.assets.texture("icon_sound_on");
        states.iconAlt = P3.assets.texture("icon_sound_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.position.set(common.STAGE_WIDTH * 0.5 + 90, common.STAGE_HEIGHT * 0.5);
        this._muteButton.clickSoundName = "sfx_click";
        this.addChild(this._muteButton);
    }

    resize() {
        super.resize();
    }

    animateIn() {
    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();
    }

    end() {
        this.signals.next.dispatch();
    }

    _onClose() {
        this.end();
    }
}